var exports = {
  "k": "container__gOlETz",
};

module.exports = exports;
